import { useQueryClient } from 'react-query'
import { queryKeys } from 'queries/queryKeys'
import { IReminder } from 'types'

export const useReminders = (): IReminder[] => {
  const queryClient = useQueryClient()
  const data = queryClient?.getQueryData<IReminder[]>(queryKeys.DOCUMENT_REMINDERS)
  return data ?? []
}
